import { article as JPB } from '../article/java_primitive_boxing' 
import { article as SBP } from '../article/spring_bean_proxy' 


const articles = {
    1: JPB,
    2: SBP
}

export default articles 